import axios from "axios";
import { sisi_api_url } from "..";
import { DateTime } from "luxon";

export const getExchangeRate = async ({ base_currency, target_currency, source_entity }) => {
  try {
    const response = await axios.get(`${sisi_api_url}/financial/exchange-rates/`, {
      params: {
        base_currency,
        target_currency,
        conversion_date: DateTime.now().toISODate(),
        source_entity,
      },
    });
    return response.data;
  } catch {
    return null;
  }
};

export async function initBarclaysPay({ payload }) {
  try {
    const response = await axios.post(`${sisi_api_url}/b2c-payment/barclays-pay/`, payload);
    return response.data;
  } catch {
    return null;
  }
}

export async function createVivaCheckout({ payload }) {
  try {
    const response = await axios.post(`${sisi_api_url}/b2c-payment/viva/checkout`, payload);
    return response.data;
  } catch {
    return null;
  }
}

export async function createFellohCheckout({ payload }) {
  if (payload["currency"] === "GBP") {
    payload["currency"] = "GBX";
  }

  try {
    const response = await axios.post(`${sisi_api_url}/b2c-payment/felloh/checkout`, payload);
    return response.data;
  } catch {
    return null;
  }
}
